"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = require("../fonts");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Header = _styledComponents.default.th.attrs(function (props) {
  return {
    children: /*#__PURE__*/_react.default.createElement(_fonts.P, null, props.children)
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  padding: 0 15px 15px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
exports.Header = Header;